import React from 'react'

const Footer = () => {
  
  return (
    <footer className="mt-10 ">
        <div className="flex gap-2 mx-auto justify-center items-center mb-2">
          <p className='text-gray-700 text-sm '> Powered By: </p>
          <a href='http://clickstar.kansals.in' target='_blank' rel="noopener noreferrer" ><img src="/logobl.png" className='h-12 ' alt="clickstar brand logo"/></a>
        </div>
  <div className="  bg-gray-100 text-gray-900 flex items-center py-2 rounded-md ">
    <p className='mx-auto'>  <a href="http://clickstar.kansals.in/shop/" rel="noopener noreferrer" 
         target="_blank" 
         className="text-gray-900 hover:underline">
         Get your own ClickStar
      </a></p>
  </div>
</footer>
  )
}

export default Footer